import { ArrayLayoutProps, createDefaultValue } from "@jsonforms/core";
import { BasicButton } from "@certn/cascadia";
import { getItemName } from "../../utils";
import { Trans, useTranslation } from "react-i18next";

export function BaseAddItemButton(props: ArrayLayoutProps) {
  const {
    label,
    uischema,
    uischema: { options },
  } = props;
  const { t } = useTranslation();

  const itemName = getItemName(uischema, label, t("Field"));

  const handleAddItem = () => {
    props.addItem(props.path, createDefaultValue(props.schema))();
  };

  return (
    <BasicButton
      onPress={handleAddItem}
      leftIcon="add"
      isDisabled={!props.enabled}
    >
      {options?.customAddSection?.buttonText ? (
        options.customAddSection.buttonText
      ) : (
        <>
          <Trans>Add</Trans> {itemName.toLowerCase()}
        </>
      )}
    </BasicButton>
  );
}
